import { StoreType } from "./redux";

const storeHolder: { store: StoreType | null } = {
  store: null
};

export default storeHolder;
